/* eslint-env es6 */

(function () {
  const script = document.createElement('script');

  script.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('charset', 'UTF-8');
  script.setAttribute('data-domain-script', 'f0e2525c-ab2b-4e3a-bef4-3eff3bc818c0-test');
  document.getElementsByTagName('head')[0].appendChild(script);
})();

function reloadOTBanner() {
  let otConsentSdk = document.getElementById('onetrust-consent-sdk');
  if (otConsentSdk) {
    otConsentSdk.remove();
  }

  if (window.OneTrust != null) {
    OneTrust.Init();

    setTimeout(function () {
      OneTrust.LoadBanner();

      let toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings');

      for (const element of toggleDisplay) {
        element.onclick = function (event) {
          event.stopImmediatePropagation();
          window.OneTrust.ToggleInfoDisplay();
        };
      }
    }, 1000);
  }
}

(function waitForUserData() {
  // GTM must load early, but the organization context (organizationName/organizationId)
  // is only populated after memberships/organizations are fetched, i.e. later than userId.
  // So inject GTM as soon as the user is known, but defer the page_view push until the
  // organization is available, with a bounded fallback so org-less sessions still report.
  const MAX_ATTEMPTS = 100; // ~10s
  let attempts = 0;
  let gtmInjected = false;
  let eventPushed = false;

  let interval = setInterval(() => {
    attempts++;

    if (!gtmInjected && window.userId) {
      gtmInjected = true;
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
        });
        let f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=fCj_XrHtknRqKCdz-Tq10Q&gtm_preview=env-3&gtm_cookies_win=x';
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-T88CCTJ');
      window.dataLayer = window.dataLayer || [];
    }

    const organizationReady = window.organizationName && window.organizationId;
    if (!eventPushed && window.userId && (organizationReady || attempts >= MAX_ATTEMPTS)) {
      eventPushed = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        user_type: window.userType,
        user_organization: window.organizationName,
        user_id: window.userId,
      });
    }

    if (eventPushed) {
      clearInterval(interval);
    }
  }, 100);
})();
